import { render, staticRenderFns } from "./feright.vue?vue&type=template&id=7664c0e4&scoped=true&"
import script from "./feright.vue?vue&type=script&lang=js&"
export * from "./feright.vue?vue&type=script&lang=js&"
import style0 from "./feright.vue?vue&type=style&index=0&id=7664c0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664c0e4",
  null
  
)

export default component.exports